import { useCallback } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useBrowserQueryState } from '@telialt/common-hooks/src/useBrowserQueryState';
import { SORT_DROPDOWN_OPTIONS, URL_SORT_PARAM } from '@telialt/core-search/src/constants';

const defaultSortLabelKey = SORT_DROPDOWN_OPTIONS[0].LABEL;

export const useCategorySortParam = (initialValue: string) => {
    const { t } = useTranslations();

    const [sortLabel, setSortLabel] = useBrowserQueryState<string>(
        URL_SORT_PARAM,
        t[defaultSortLabelKey],
        initialValue,
    );

    const selectedSortOption =
        SORT_DROPDOWN_OPTIONS.find((option) => t[option.LABEL] === sortLabel) || SORT_DROPDOWN_OPTIONS[0];

    const changeSort = useCallback(
        (selectedValue: string) => {
            const selectedLabelKey =
                SORT_DROPDOWN_OPTIONS.find((option) => option.VALUE === selectedValue)?.LABEL || defaultSortLabelKey;

            setSortLabel(t[selectedLabelKey]);
        },
        [setSortLabel, t],
    );

    const sortValue = selectedSortOption.VALUE;
    const sortFields = selectedSortOption.SORT_ARRAY;

    return { sortValue, sortFields, changeSort };
};
